import React, { useContext, useEffect, useState } from 'react';
import { Header, Icon } from 'semantic-ui-react';
import Wrapper, { wrapperTypes } from './Wrapper';
import MiniSwipe from 'global/components/swipers/MiniSwipe';
import { AppDashboardContext } from 'global/components/viewers/AppDashboardOptions';

const WrapperVertCols = ({
  children,
  mvc,
  split,
  cn,
  noDarkMode,
  forApp,
  handleSelectedIndex,
  applySwiper,
  selected_index
}) => {

  // appDashboardContext
  const appDashboardContext = useContext(AppDashboardContext);
  const { appDashboard_state } = appDashboardContext ?? {}
  const { isSplit } = appDashboard_state ?? {}

  const _split = isSplit || split

  const [selectedIndex, setSelectedIndex] = useState(0);
  const [headers, setHeaders] = useState([])
  const [contents, setContents] = useState([])

  useEffect(() => {
    if (_split) {
      const _headers = []
      const _contents = []
      _.forEach(children, (item) => {
        const { content, header, footer, menuItems, json, name } = item?.props ?? {}
        if (header) { _headers.push(header) }
        if (content) { _contents.push(content) }
        if (menuItems) { _contents.push(item) }
        if (name) { _headers.push(name) }
        if (json) { _contents.push(json) }
      })
      setHeaders(_headers)
      setContents(_contents)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [children, _split]);

  useEffect(() => {
    if (_split && handleSelectedIndex) {
      handleSelectedIndex(selectedIndex)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIndex]);

  useEffect(() => {
    if (_split && selected_index) {
      // setSelectedIndex(selected_index)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selected_index]);

  const handlePrev = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === 0 ? headers.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setSelectedIndex((prevIndex) =>
      prevIndex === headers.length - 1 ? 0 : prevIndex + 1
    );
  };

  const header = (h) => <Header as="h5" textAlign="center" style={{ display: "flex", color: 'white', alignItems: "center", justifyItems: 'center', padding: '.5em' }}>
    <div style={{ flex: "5%", textAlign: "left" }}>
      <Icon name="arrow left" onClick={handlePrev} style={{ cursor: "pointer" }} disabled={selectedIndex === 0} />
    </div>
    <div style={{ flex: "90%", textAlign: "center" }}>{h}</div>
    <div style={{ flex: "5%", textAlign: "right" }}>
      <Icon name="arrow right" onClick={handleNext} style={{ cursor: "pointer" }} disabled={selectedIndex === (headers.length - 1)} />
    </div>
  </Header>

  if (_split) {
    return <Wrapper
      header={header(headers && headers[selectedIndex])}
      content={<div className={' menu-vert-cols mvc-1'}>
        {contents && contents[selectedIndex]}
      </div>}
      wrapperType={wrapperTypes.paddedHeader}
    ></Wrapper>
  } else {
    let _cn;
    if (forApp) {
      _cn = 'app-dark-mode app-vert-cols mvc-' + mvc
    } else {
      _cn = 'app-dark-mode menu-vert-cols mvc-' + mvc
    }
    if (cn) {
      _cn += ' ' + cn
    }
    if (noDarkMode) {
      _cn = _cn.replace('app-dark-mode ', '')
    }

    if (applySwiper) {
      return (
        <MiniSwipe swipeItems={children} />
      )
    } else {
      return (
        <div className={_cn}>
          {children}
        </div>
      )
    }

  }

}

export default WrapperVertCols